import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/// <reference types="cordova-plugin-autostart/types"/>
/// <reference types="cordova-plugin-fingerprint-aio/types"/>
import { memo, useCallback, useEffect, useState } from 'react';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { open_ask_pin_dialog, open_set_pin_dialog, set_require_fingerprint, } from './redux/actions';
import { getUiVersion, isAndroidApp } from 'utils';
import { showThemeElement } from '../theme/utils';
import { changeUserTheme } from '../theme/actions';
import { selectThemeType } from '../theme/selector';
import { WidgetsSelector } from './widget-selector';
import { ThemeType, themeTypeTranslator } from '../theme/types';
import { useMounted } from 'shared/hooks/utils';
import { Box, Checkbox, List, ListItemButton, ListItemSecondaryAction, ListItemText, Typography, } from '@mui/material';
import { SmallThemeSwitcher } from '../theme/small-theme-switcher';
import { ErrorBoundary } from 'shared/components/error-boundary';
export const AppSettingsContent = memo(function AppSettingsContentImpl() {
    const isMounted = useMounted();
    const settings = useAppSelector((state) => state.app_settings.settings);
    const theme_type = useAppSelector(selectThemeType);
    const onSetRequireFingerprint = useAction(set_require_fingerprint);
    const onChangeUserTheme = useAction(changeUserTheme);
    const openSettingPinDialog = useAction(open_set_pin_dialog);
    const openAskingPinDialog = useAction(open_ask_pin_dialog);
    const [fingerprint_support, setFingerPrintSupport] = useState(null);
    useEffect(() => {
        // It is important to not call Fingerprint's methods on app startup,
        // because Fingerprint seems to be non-reenterable and startup authentication
        // process might be broken by intermediate isAvailable() call
        if (isMounted.current) {
            window.Fingerprint?.isAvailable((result) => setFingerPrintSupport(result), (error) => {
                console.error('Fingerprint isAvailable', error);
                setFingerPrintSupport(null);
            });
        }
    }, []);
    const on_pin_checkbox_change = useCallback(() => {
        if (settings.pin != null) {
            openAskingPinDialog();
        }
        else {
            openSettingPinDialog();
        }
    }, [settings.pin, openAskingPinDialog, openSettingPinDialog]);
    const on_fingerprint_change = useCallback(() => {
        window.Fingerprint?.registerBiometricSecret({
            title: 'Вход по отпечатку',
            description: 'Приложите палец чтобы продолжить',
            secret: 'fingerprint',
            invalidateOnEnrollment: true,
            disableBackup: true,
            cancelButtonTitle: 'Отменить',
        }, () => onSetRequireFingerprint(!settings.require_fingerprint), (error) => {
            console.error(error);
        });
    }, [onSetRequireFingerprint, settings.require_fingerprint]);
    const onChangeTheme = useCallback(() => {
        const new_theme = theme_type === ThemeType.DARK ? ThemeType.SYSTEM : theme_type + 1;
        onChangeUserTheme(new_theme);
    }, [onChangeUserTheme, theme_type]);
    return (_jsxs(ErrorBoundary, { children: [_jsxs(List, { children: [_jsxs(ListItemButton, { onClick: on_pin_checkbox_change, divider: true, children: [_jsx(ListItemText, { primary: "\u0417\u0430\u043F\u0440\u043E\u0441 \u043F\u0438\u043D-\u043A\u043E\u0434\u0430 \u043F\u0440\u0438 \u0437\u0430\u043F\u0443\u0441\u043A\u0435" }), _jsx(ListItemSecondaryAction, { children: _jsx(Checkbox, { edge: "end", color: "primary", onChange: on_pin_checkbox_change, checked: settings.pin != null }) })] }), fingerprint_support && (_jsxs(ListItemButton, { onClick: on_fingerprint_change, divider: true, children: [_jsx(ListItemText, { primary: `Вход по ${fingerprint_support === 'face'
                                    ? 'Face ID'
                                    : 'отпечатку пальца'}` }), _jsx(ListItemSecondaryAction, { children: _jsx(Checkbox, { edge: "end", color: "primary", checked: settings.require_fingerprint }) })] })), showThemeElement() && (_jsxs(ListItemButton, { onClick: onChangeTheme, divider: true, children: [_jsx(ListItemText, { primary: themeTypeTranslator[theme_type] + ' тема' }), _jsx(ListItemSecondaryAction, { children: _jsx(SmallThemeSwitcher, { useNotInHeader: true }) })] }))] }), window.ZontNotificationWidget != null && isAndroidApp() && (_jsx(WidgetsSelector, {})), _jsxs(Box, { mt: 2, mx: 2, display: "flex", justifyContent: "space-between", alignItems: "center", children: [_jsx(Typography, { variant: "subtitle1", children: "\u0412\u0435\u0440\u0441\u0438\u044F \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F" }), _jsx(Typography, { variant: "subtitle1", color: "textSecondary", children: getUiVersion() })] })] }));
});
